import { CancelFunctions } from 'components/common/types';
import {
  ActivatedNonMediaService,
  GenerateNonMediaServicesPayloadProps,
  GetSelectedNonMediaServicesPayload,
  NonMediaService,
  NonMediaServicesPayload,
} from 'components/common/types/NonMediaServices.types';
import { HEADERS_CONTENT_TYPE, HTTP_METHODS, URLS } from 'modules/api/constants';
import createRequest from './request';

export const generateNonMediaServicesPayload = ({
  campaignLengthInWeeks = 0,
  numberOfImpressions = 0,
  dealType,
  dsp,
  country,
  marketId,
  isReseller,
  categoryFilters,
  servicesSearchQuery,
}: GenerateNonMediaServicesPayloadProps): NonMediaServicesPayload => {
  const marketDimension = {
    type: !isReseller ? 'MEDIA_OWNER' : 'RESELLER',
    codes: [marketId],
  };

  const categoryCodes = categoryFilters?.map((category) => category.code) || [];

  return {
    minFlightRequirements: campaignLengthInWeeks,
    minImpressionRequirements: numberOfImpressions,
    eligibilityRules: [
      {
        dimensions: [
          {
            type: 'DEAL_TYPE',
            codes: [dealType],
          },
          {
            type: 'DSP',
            codes: [dsp.code],
          },
          {
            type: 'COUNTRY',
            codes: [country.code],
          },
          marketDimension,
        ],
      },
    ],
    categoryCodes,
    name: servicesSearchQuery,
  };
};

export const getNonMediaServices = async (
  cancelFunctions: CancelFunctions,
  payload: NonMediaServicesPayload,
): Promise<NonMediaService[]> => {
  const reqOptions = {
    url: URLS().FETCH_NON_MEDIA_SERVICES(),
    method: HTTP_METHODS.POST,
    data: JSON.stringify(payload),
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  const { send, cancel } = createRequest(reqOptions);

  if (cancelFunctions.FETCH_NON_MEDIA_SERVICES) cancelFunctions.FETCH_NON_MEDIA_SERVICES();
  cancelFunctions.FETCH_NON_MEDIA_SERVICES = cancel;

  const result = await send();

  return result.data;
};

export const getSelectedNonMediaServices = async (
  cancelFunctions: CancelFunctions,
  payload: GetSelectedNonMediaServicesPayload,
): Promise<ActivatedNonMediaService[]> => {
  const reqOptions = {
    url: URLS().FETCH_SELECTED_NON_MEDIA_SERVICES(),
    method: HTTP_METHODS.POST,
    data: JSON.stringify(payload),
    headers: {
      'Content-Type': HEADERS_CONTENT_TYPE.APPLICATION_JSON,
    },
  };

  const { send, cancel } = createRequest(reqOptions);

  if (cancelFunctions.FETCH_SELECTED_NON_MEDIA_SERVICES) cancelFunctions.FETCH_SELECTED_NON_MEDIA_SERVICES();
  cancelFunctions.FETCH_SELECTED_NON_MEDIA_SERVICES = cancel;

  const result = await send();

  return result.data;
};
